import { IGetPropertyPhotosDTO } from '@/models/photos.model';

class GetPropertyPhotosDTO implements IGetPropertyPhotosDTO {
  property_id: string;
  constructor({ id }: { id: string }) {
    this.property_id = id;
  }
}

export default GetPropertyPhotosDTO;
